import { el } from '../lib/dom.js';
import { countUp } from '../lib/anim.js';

const NS = 'http://www.w3.org/2000/svg';

function circle(r, cls) {
  const c = document.createElementNS(NS, 'circle');
  c.setAttribute('cx', '26');
  c.setAttribute('cy', '26');
  c.setAttribute('r', String(r));
  c.setAttribute('class', cls);
  return c;
}

/**
 * Compact circular progress used in the dex feed header. Returns
 * { node, update } — update({ caught, seen, total }) re-draws the arcs and
 * the centre label without rebuilding.
 */
export function ProgressRing() {
  const R = 22;
  const CIRC = 2 * Math.PI * R;

  const track = circle(R, 'ring__track');
  const seenArc = circle(R, 'ring__seen');
  const caughtArc = circle(R, 'ring__caught');
  for (const arc of [seenArc, caughtArc]) {
    arc.setAttribute('stroke-dasharray', String(CIRC));
    arc.setAttribute('stroke-dashoffset', String(CIRC));
    arc.setAttribute('transform', 'rotate(-90 26 26)');
  }

  const svg = document.createElementNS(NS, 'svg');
  svg.setAttribute('viewBox', '0 0 52 52');
  svg.setAttribute('class', 'ring__svg');
  svg.append(track, seenArc, caughtArc);

  const num = el('span', { class: 'ring__num' }, '0');
  const tail = el('small', {});
  const value = el('span', { class: 'ring__value' }, num, tail);
  const node = el(
    'a',
    {
      class: 'ring',
      href: '#/progress',
      title: 'Progress by game',
      'aria-label': 'Progress by game',
    },
    svg,
    el('div', { class: 'ring__label' }, value),
  );

  let first = true;
  let shown = 0;
  function update(stats) {
    const draw = () => {
      const { caught = 0, seen = 0, total = 1 } = stats;
      const safeTotal = Math.max(total, 1);
      caughtArc.setAttribute('stroke-dashoffset', String(CIRC * (1 - caught / safeTotal)));
      seenArc.setAttribute(
        'stroke-dashoffset',
        String(CIRC * (1 - Math.max(seen, caught) / safeTotal)),
      );
      tail.textContent = `/${total}`;
      // Keep the accessible name in sync with the visible count (avoids an
      // aria-label / visible-text mismatch).
      node.setAttribute('aria-label', `Progress by game: ${caught} of ${total} caught`);
      countUp(num, caught, { from: shown, duration: first ? 700 : 350 });
      shown = caught;
    };
    // Defer the first draw a frame so the arc animates in from empty.
    if (first) {
      first = false;
      requestAnimationFrame(draw);
    } else {
      draw();
    }
  }

  return { node, update };
}
